var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocalLiterature(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.951 61.809v90.311h-92.474V0H0v512h512V61.809zm236.049 30v30.763h-48.896V91.809zm-206.049 60.762h48.255v30.004h-48.255zm78.255 0h48.897v30.004h-48.897zm78.898 0H482v30.004h-48.896zm-30-60.762v30.763h-48.897V91.809zm-78.898 0v30.763h-48.255V91.809zM123.478 29.974v94.153H30V29.974zM30 482V154.127h93.478V482zm215.951 0h-92.474V182.12h92.474zm30 0V212.575h48.255V482zm78.255 0V212.575h48.897V482zm78.898 0V212.575H482V482z",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.116 308.845h30v138.639h-30zM60.997 416.202h30v31.282h-30zM60.997 261.246h30v119.599h-30zM60.997 64.125h30v31.282h-30z",
    "data-original": "#000000"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalLiterature);
export default __webpack_public_path__ + "static/media/local-literature.cd84c347d25259d1610d09d3cac648e6.svg";
export { ForwardRef as ReactComponent };